// Página previa mientras carga la nueva (sin parpadeo al paginar), pero SOLO si es de la
// misma empresa: al cambiar de empresa activa no se muestran datos de la anterior bajo el
// nombre de la nueva. Convención: la empresa va en la posición 1 del queryKey.

interface PreviousQuery {
  queryKey: readonly unknown[];
}

export function keepPreviousForCompany<T>(
  companyId: string | null,
): (previous: T | undefined, previousQuery: PreviousQuery | undefined) => T | undefined {
  return (previous, previousQuery) =>
    previousQuery?.queryKey[1] === companyId ? previous : undefined;
}
